import Vue from 'vue'
import Router from 'vue-router'
import EditConstants from '@/views/EditConstants.vue'
import DesignerSignUp from '@/views/Designer/DesignerSignUp.vue'
import DesignersView from '@/views/Designer/DesignersView.vue'
import DesignerView from '@/views/Designer/DesignerView.vue'
import EmbeddableView from '@/views/Embeddable.vue'
import Login from '@/views/Login.vue'
import DummyAuthView from '@/views/DummyAuthView.vue'
import NotFoundView from '@/views/NotFoundView.vue'
import {
  loginGuard,
  authGuard
} from './guards'
import UserBus from '@/utils/buses/UserBus'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'designers',
      component: DesignersView
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: loginGuard
    },
    {
      path: '/edit/constants',
      name: 'editConstants',
      component: EditConstants
    },
    {
      path: '/designer/sign-up',
      name: 'designerSignup',
      component: DesignerSignUp
    },
    {
      path: '/designer/:name/:id',
      name: 'designer',
      component: DesignerView
    },
    {
      path: '/dummy/auth/view',
      name: 'dummyAuthView',
      component: DummyAuthView,
      beforeEnter: authGuard
    },
    {
      path: '*',
      name: 'notFound',
      component: NotFoundView
    }
  ]
})

router.beforeEach((to, from, next) => {
  // check if token has expired
  UserBus.tokenHasExpired()
  next()
})

export default router
